import React from "react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Notification } from "../hooks/useNotifications";
import { Bell } from "lucide-react";

interface NotificationPopoverProps {
  notifications: Notification[];
  unreadCount: number;
  onNotificationClick: (notification: Notification) => void;
  onSeeMoreClick?: () => void;
  triggerComponent?: React.ReactNode; // optional custom trigger
}

export const NotificationPopover: React.FC<NotificationPopoverProps> = ({
  notifications,
  unreadCount,
  onNotificationClick,
  onSeeMoreClick,
  triggerComponent,
}) => {
  return (
    <Popover>
      <PopoverTrigger asChild>
        {triggerComponent ? (
          triggerComponent
        ) : (
          // default trigger (Bell + count)
          <div className="relative cursor-pointer">
            <Bell className="h-5 w-5 text-gray-700" />
            {unreadCount > 0 && (
              <span className="absolute top-1 right-1 flex h-4 w-4 items-center justify-center rounded-full bg-green-500 text-[10px] text-white font-semibold">
                {unreadCount > 9 ? "9+" : unreadCount}
              </span>
            )}
          </div>
        )}
      </PopoverTrigger>

      <PopoverContent
        align="end"
        className="w-52 p-0 rounded-lg shadow-lg shadow-gray-200 bg-white"
      >
        <div className="flex flex-col">
          {notifications.length === 0 && (
            <div className="text-gray-600 text-center py-3">
              No new notification
            </div>
          )}

          {notifications.map((notification) => (
            <div
              key={notification.id}
              className="py-3 border-b last:border-b-2 rounded-lg p-3 border-b-gray-200 
                         bg-white text-gray-800 flex items-center justify-between cursor-pointer hover:bg-gray-50"
              onClick={() => onNotificationClick(notification)}
            >
              <div>
                <strong className="block font-semibold text-sm">
                  {notification.title}
                </strong>
                <p className="mt-1 text-xs">{notification.description}</p>
              </div>
            </div>
          ))}

          {notifications.length > 0 && onSeeMoreClick && (
            <div
              className="text-gray-600 text-center py-2 cursor-pointer hover:underline"
              onClick={onSeeMoreClick}
            >
              See More
            </div>
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
};
